import { defineMessages } from 'react-intl'

const messages = defineMessages({
  facilities: {
    id: 'global.facilities',
  },
  wifi: {
    id: 'global.wifi',
  },
  carpark: {
    id: 'global.car-park',
  },
  gym: {
    id: 'global.gym',
  },
  outdoorpool: {
    id: 'global.outdoor-pool',
  },
  indoorpool: {
    id: 'global.indoor-pool',
  },
  spa: {
    id: 'global.spa',
  },
  restaurant: {
    id: 'global.restaurant',
  },
  wheelchair: {
    id: 'global.wheelchair',
  },
  airportshuttle: {
    id: 'global.airport-shuttle',
  },
  safebox: {
    id: 'global.safebox',
  },
})

export default messages
